<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">
        {{ $t("add") }} {{ $tc("cinema", 1) }} {{ $tc("type", 1) }}
      </div>
      <router-link class="btn-blue" :to="{ name: 'Cinema Types' }"
        >{{ $tc("cinema", 1) }} {{ $tc("type", 2) }}
        {{ $tc("list", 1) }}</router-link
      >
    </div>

    <div class="white-wrapper" style="padding:10px 20px">
      <div class="row" style="height:55px">
        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                id="cinema_type_name"
                name="cinema_type_name"
                v-validate="'required|alpha_spaces'"
                v-model="cinema_type_name"
                placeholder="."
                v-b-tooltip.hover
                :title="$t('cinema_type_name')"
              />
              <label
                >{{ $tc("cinema", 1) }} {{ $tc("type", 1) }}
                {{ $t("name") }}</label
              >
            </div>
            <!--Tooltip :title="$t('cinema_type_name')" /-->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('cinema_type_name')">{{
              errors.first("cinema_type_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center pt-3">
            <b-form-checkbox
              type="checkbox"
              class="j-checkbox mb-0"
              v-model="cine_type_is_active"
              true-value="Y"
              false-value="N"
            />

            <label class="mb-0 mr-2">{{ $t("active") }}</label>
          </div>
        </div>

        <div class="text-center btn_position">
          <button @click.prevent.stop="addCinemaType()" class="btn-blue">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      submitted: false,
      cinema_type_name: "",
      cine_type_is_active: "Y"
    };
  },
  methods: {
    addCinemaType() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          // let loader = this.$loading.show();

          // console.log("JSON.stringify :", JSON.stringify(finalObj));
          let payload = {
            cinema_type_name: this.cinema_type_name,
            cine_type_is_active: this.cine_type_is_active
          };
          MasterService.AddCinemaType(payload)
            .then(response => {
              const { data } = response;
              // loader.hide();
              if (data && data.status) {
                this.$toasted.show(data.message);

                this.$router.push({
                  path: "/master/cinema-types"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CinemaTypeComponents/addCinemaType.vue